<template>
    <nav
        v-click-outside="closeMenu"
        :class="menuStatus"
        class="navbar"
        @keydown.esc="closeMenu"
    >
        <div class="navbar__aos-tracker"></div>

        <div class="navbar__wrapper">
            <div class="position-relative">
                <button
                    class="hamburger hamburger--spin"
                    :class="{ 'is-active': isActive }"
                    type="button"
                    title="toggle-menu"
                    @click="toggleMenu"
                >
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                    menu
                </button>
            </div>

            <a
                class="navbar__brand-link"
                aria-label="home"
                :href="menuModel.rootUrl"
            >
                <Logo />
            </a>

            <search-box v-if="isSearchPage"></search-box>
        </div>

        <div class="navbar__drawer" :class="{ 'is-active': isActive }">
            <perfect-scrollbar ref="scrollbar" class="navbar__scroll-area">
                <ul
                    v-if="menuModel.languageMenuItemModel !== null"
                    class="lang__items mt-1 mb-2 d-flex flex-wrap"
                >
                    <li
                        v-for="languageMenuItem in menuModel.languageMenuItemModel"
                        :key="languageMenuItem.id"
                        class="navbar__item"
                    >
                        <a
                            :href="languageMenuItem.url"
                            class="navbar__link"
                            :class="{ 'is-active': languageMenuItem.isActive }"
                        >
                            {{ languageMenuItem.menuTitle }}
                        </a>
                    </li>
                </ul>
                <ul class="navbar__items">
                    <li
                        v-if="
                            menuModel.languageMenuItemModel == null ||
                                menuModel.languageMenuItemModel.length == 0
                        "
                        class="navbar__item"
                    >
                        <a :href="menuModel.rootUrl" class="navbar__link">
                            <i class="fas fa-home"></i>Home
                        </a>
                    </li>
                    <li
                        v-if="
                            menuModel.languageMenuItemModel == null ||
                                menuModel.languageMenuItemModel.length == 0
                        "
                        class="navbar__item"
                    >
                        <a :href="menuModel.favoritesUrl" class="navbar__link">
                            <i class="fas fa-heart"></i>Favoriete opleidingen
                        </a>
                    </li>
                    <li
                        v-for="menuItem in menuModel.menuItems"
                        :key="menuItem.id"
                        class="navbar__item"
                    >
                        <NavBarSubItem
                            v-if="
                                menuItem.subMenuItems !== null &&
                                    menuItem.subMenuItems.length
                            "
                            :menu-item="menuItem"
                        ></NavBarSubItem>

                        <a
                            v-else
                            :key="menuItem.id"
                            :href="menuItem.url"
                            class="navbar__link"
                            :class="{ 'is-active': menuItem.active }"
                        >
                            {{ menuItem.getTitle }}
                        </a>
                    </li>
                </ul>
            </perfect-scrollbar>
            <div class="navbar__arrow">
                <BouncyArrow />
            </div>
        </div>
    </nav>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import Logo from '@/components/nav/logo';
import NavBarSubItem from '@/components/nav/navbar-subitem';
import SearchBox from '@/components/nav/search-box';
import { EventBus } from '@/js/helpers/eventbus';
import BouncyArrow from '@/components/bouncy-arrow';

export default {
    components: {
        Logo,
        NavBarSubItem,
        SearchBox,
        PerfectScrollbar,
        BouncyArrow
    },

    directives: {
        ClickOutside
    },

    props: {
        menuModel: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            isActive: false,
            isSearchPage: true,
            bottom: 'auto'
        };
    },

    computed: {
        offsetBottom() {
            return {
                bottom: this.bottom
            };
        },
        menuStatus() {
            if (this.menuModel.hideNavbar) {
                return 'error-page';
            } else {
                return '';
            }
        }
    },

    mounted() {
        this.isSearchPage = this.$root.settings.isSearchPage;
        EventBus.$on('toggle-sub-item', () => {
            setTimeout(() => {
                this.$refs.scrollbar.update();
            }, 500);
        });

        window.addEventListener('resize', this.setBottom);
        this.setBottom();
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.setBottom);
    },

    methods: {
        toggleMenu() {
            this.isActive = !this.isActive;
        },

        closeMenu() {
            this.isActive = false;
        },
        setBottom() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                if (
                    document.querySelector('#cookiebar') &&
                    typeof document.querySelector('#cookiebar') !== 'undefined'
                ) {
                    this.bottom =
                        document.querySelector('#cookiebar').clientHeight +
                        'px';
                }
            }, 300);
        }
    }
};
</script>

<style lang="scss">
@import '~vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
.ps__rail-y {
    opacity: 0.6 !important;
}

.navbar__aos-tracker {
    position: absolute;
    top: 100vh;
    left: 0;
    width: 1px;
    height: 1px;
    visibility: hidden;
    opacity: 0;
}

.navbar__wrapper {
    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    padding: 0 15px;
    background-color: $color-white;
    pointer-events: none;
    z-index: 150;

    @include media-breakpoint-up(md) {
        align-items: flex-start;
        height: 130px;
        padding: 0 30px;
        padding-top: 2rem;
    }
}

.navbar__brand-link {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    pointer-events: all;
    transform: translate(-50%, -50%);

    .logo {
        height: 80px;
        padding: 1rem 0;
    }

    @include media-breakpoint-up(md) {
        .logo {
            height: 130px;
            padding: 1.5rem 0;
        }
    }
}

.navbar__brand {
    position: fixed;
    width: 100%;
}

.navbar__brand-short {
    position: absolute;
    font-family: $font-family-condensed;
    line-height: 1;
    width: 45px;
    top: -40px;
    text-align: center;
    font-size: 2.5rem;
    pointer-events: all;

    &:hover {
        text-decoration: none;
    }
}

.navbar__drawer {
    position: fixed;
    pointer-events: all;
    top: 0;
    left: 0;
    width: 90vw;
    height: calc(100% + 200px);
    padding-top: 80px;
    padding-bottom: 200px;
    z-index: 101;
    background-color: $color-white;
    transform: translateX(-100%);
    transition: transform 0.5s $easeOutQuad;

    @include media-breakpoint-up(sm) {
        width: 80vw;
    }

    @include media-breakpoint-up(md) {
        padding-top: 120px;
        width: 50vw;
    }

    @include media-breakpoint-up(lg) {
        width: 30vw;
    }

    @include media-breakpoint-up(xl) {
        width: 25vw;
    }
}

.navbar__arrow {
    position: relative;
    display: none;
    margin-top: 50px;
    z-index: 1000;
}
.ps--active-y + .navbar__arrow {
    display: block;
}

.navbar__drawer.is-active {
    transform: translateX(0);
    border-right: solid 1px #f1f1f1;
}

.navbar__scroll-area {
    margin: 0;
    width: 100%;
    height: calc(100% - 50px);
    z-index: 30;
    -webkit-overflow-scrolling: touch;

    @include media-breakpoint-up(md) {
        height: calc(100% - 50px);
    }
}

.navbar__brand-drawer {
    height: 100px;
    display: block;
    background-color: $white;
    z-index: 200;
    padding-left: 40px;
    width: 100%;

    .logo {
        height: 100px;
        padding: 1.5rem 0;
    }

    @include media-breakpoint-up(md) {
        .logo {
            height: 130px;
        }
    }
}

.navbar__items {
    margin: 0;
    background-color: $color-white;
    padding-left: 40px;
    list-style: none;
    font-weight: $font-weight-light;
    font-size: 1.125rem;
    line-height: 2.2;
    letter-spacing: 0.33px;
}

.navbar__link {
    display: block;
    position: relative;
    cursor: pointer;

    i {
        margin-right: 0.5rem;
    }

    &.is-active {
        font-weight: $font-weight-medium;
    }

    &:before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%) scale(0);
        left: -1rem;
        width: 7px;
        height: 7px;
        border-radius: 4px;
        background-color: $color-blue;
        opacity: 0;
        transition: transform 0.25s $easeOutQuad, opacity 0.25s $easeOutQuad;
    }

    &.is-active {
        text-decoration: none;

        &:before {
            transform: translateY(-50%) scale(1);
            opacity: 1;
        }
    }

    &:hover {
        text-decoration: none;
    }

    @include media-breakpoint-up(md) {
        &:hover {
            &:before {
                transform: translateY(-50%) scale(1);
                opacity: 1;
            }
        }
    }
}

.lang__items {
    list-style: none;
}

.lang__items .navbar__item {
    margin: 0 15px;
}

.lang__items .navbar__item:first-child {
    margin-left: 0;
}

.lang__items .navbar__item .navbar__link:before {
    width: 100%;
    height: 2px;
    bottom: 0;
    top: auto;
    left: 0;
    border-radius: 0;
    background-color: $color-orange;
}
</style>
